import React from 'react';

import { useIntl } from 'react-intl';

import { HomePage } from 'components/features/home-page';
import { ModalBlockRegion } from 'components/modal-block-region';
import { ModalInvitationCodeAfterSignUp } from 'components/modal-invitation-code-after-sign-up';
import { ModalQuestUnlockedIncentive } from 'components/modal-quest-unlocked-incentive';
import { useBlockedByRegion } from 'hooks/use-block-by-region/use-block-by-region';
import { useFeatureInvitationCode } from 'hooks/use-feature-invitation-code';
import { LoyaltyBanner } from 'pages/loyalty/loyalty-banner';
import { LoyaltyCtaBar } from 'pages/loyalty/loyalty-cta-bar';
import { selectors, useAppSelector } from 'state/global-state';
import { useLocationContext } from 'state/location';
import { useLoyaltyQuests } from 'state/loyalty/hooks/use-loyalty-quests';
import { isMobile } from 'utils/environment';

interface ILocationState {
  triggerSignInAccessibility: string;
}

const Home = () => {
  const { location } = useLocationContext();
  const { triggerSignInAccessibility } = (location?.state || {}) as ILocationState;
  const { formatMessage } = useIntl();
  const { isBlockedByRegion } = useBlockedByRegion();
  const { enableInvitationCode } = useFeatureInvitationCode();
  const loyaltyUser = useAppSelector(selectors.loyalty.selectUser);
  const {
    onChangeSignUpModalOfferVisibility,
    onChangeUnlockedIncentivesModalVisibilityStatus,
    unlockedIncentivesModalVisibilityStatus,
    signUpModalOfferVisibility,
  } = useLoyaltyQuests(loyaltyUser?.id ?? '');

  const signInAccessibilityMsg = triggerSignInAccessibility
    ? formatMessage({ id: 'visuallyHiddenSignInSuccess' })
    : '';

  return (
    <div data-testid="homepage" aria-label={signInAccessibilityMsg} role="alert">
      {isMobile() && <LoyaltyCtaBar />}
      <LoyaltyBanner />
      <ModalBlockRegion show={isBlockedByRegion()} />
      <HomePage />

      {enableInvitationCode && loyaltyUser && (
        <ModalInvitationCodeAfterSignUp
          onChangeSignUpModalOfferVisibility={onChangeSignUpModalOfferVisibility}
          signUpModalOfferVisibility={signUpModalOfferVisibility}
        />
      )}
      {enableInvitationCode && loyaltyUser && (
        <ModalQuestUnlockedIncentive
          onChangeUnlockedIncentivesModalVisibilityStatus={
            onChangeUnlockedIncentivesModalVisibilityStatus
          }
          unlockedIncentivesModalVisibilityStatus={unlockedIncentivesModalVisibilityStatus}
        />
      )}
    </div>
  );
};

export default Home;
